import React from 'react'
import styled from 'styled-components';
import { SearchInput } from '../../../../../generic/ui/SearchInput';
import { DateRangePicker } from '../../../../../generic/ui/DatePicker';
import StatusFilterButton from '../Components/StatusFilterButton';

// Local shell for the new Orders SelectBar layout — no shared usage.
const SelectBarShell = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
`

export default function SelectBar({ input, setInput, value, setSelectedDateStart, setSelectedDateEnd, statusId, onStatusChange}) {
    const today = new Date();
    const defaultEnd = new Date();
    defaultEnd.setDate(defaultEnd.getDate() + 4);

    return (
        <SelectBarShell>

            <SearchInput
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder='חיפוש'
            />
            <DateRangePicker
                selected={[today, defaultEnd]}
                setDate={setSelectedDateStart}
                setDateEnd={setSelectedDateEnd}
            />
            {onStatusChange && (
                <StatusFilterButton value={statusId ?? null} onChange={onStatusChange} />
            )}
        </SelectBarShell>
    )
}
